import React from 'react';
import { Descriptions, Divider, Table } from 'antd';
import WithLoadPOTemplate from '../../WithLoadPOTemplate';
import SelectTemplate from 'app/pages/BookInspection/components/Steps/InspectionCriteria/SelectTemplate';
import { isNaN } from 'lodash';
import Panel from 'app/components/Layout/Panel';
import { ProductListItem } from 'app/components/List';
import classes from './Style.module.scss';
import WithFetchSampleSize from '../../WithFetchSampleSize';
import cn from 'classnames';

export default function POItem(props) {
  const {
    value: record,
    inspectionRequirement,
    onChange,
    templates = [],
    index,
    hiddenTemplate,
    className,
    bordered = true,
    children = null,
    sampleSize = null,
  } = props;
  const { inspectionAQL, inspectionSubPOItems, inspectionCriteria } = record;
  const [openEditTemplate, setOpenEditTemplate] = React.useState(false);
  const [currentEditProductTemplate, setCurrentEditProductTemplate] =
    React.useState({
      poItemId: '',
      productId: '',
      template: {
        inspectionOption: '',
        name: '',
        scheme: '',
        id: '',
      },
      index: -1,
    });
  return (
    <WithFetchSampleSize
      skip={!!sampleSize}
      quantity={inspectionSubPOItems
        .map(({ orderQty }) => Number(orderQty))
        .filter((orderQty) => !isNaN(orderQty))
        .reduce((a, b) => a + b, 0)}
      requirement={{
        critical: inspectionAQL.criticalLevel,
        major: inspectionAQL.criticalMajorLevel,
        minor: inspectionAQL.criticalMinorLevel,
        inspectionLevel: inspectionRequirement.generalInspectLevel,
      }}
      defectAccepted={record.defectAccepted}
      sampleSize={sampleSize}
    >
      {(sample) => {
        return (
          <div style={{ marginBottom: 16 }}>
            <ProductListItem
              bordered={bordered}
              order={index + 1}
              className={cn(classes.item, className)}
              image={record.image}
              name={record.name}
              itemNo={record.itemNo || 'N/A'}
              supplier={record.supplierName || 'N/A'}
              factory={record.factoryName || 'No Factory Linkage'}
            >
              <Divider />
              <Descriptions
                column={{
                  xs: 1,
                  md: 1,
                  lg: 2,
                  xl: 3,
                }}
                className={classes.descriptions}
                title="Overall"
                labelStyle={{ minWidth: 120 }}
              >
                <Descriptions.Item label="Total Order Qty.">
                  {record.inspectionSubPOItems
                    .map((item) => Number(item.orderQty))
                    .filter((item) => !isNaN(item))
                    .reduce((a, b) => a + b, 0)}
                </Descriptions.Item>
                <Descriptions.Item label="Total # of Cartons">
                  {record.inspectionSubPOItems
                    .map((item) => Number(item.cartonsNo))
                    .filter((item) => !isNaN(item))
                    .reduce((a, b) => a + b, 0)}
                </Descriptions.Item>

                <Descriptions.Item label="Signed Sample Available">
                  {record.isSignSample ? 'Yes' : 'No'}
                </Descriptions.Item>
                <Descriptions.Item label="Sample Size">
                  {sample.sampleSize ? (
                    <div className={classes.groupAQL}>
                      <span>
                        <p>Critical</p>
                        <p>{sample.sampleSize.critical || 0}</p>
                      </span>
                      <span>
                        <p>Major</p>
                        <p>{sample.sampleSize.major || 0}</p>
                      </span>
                      <span>
                        <p>Minor</p>
                        <p>{sample.sampleSize.minor || 0}</p>
                      </span>
                    </div>
                  ) : null}
                </Descriptions.Item>
                <Descriptions.Item label="AQL">
                  <div className={classes.groupAQL}>
                    <span>
                      <p>Critical</p>
                      <p>{record.inspectionAQL.criticalLevel || 0}</p>
                    </span>
                    <span>
                      <p>Major</p>
                      <p>{record.inspectionAQL.criticalMajorLevel || 0}</p>
                    </span>
                    <span>
                      <p>Minor</p>
                      <p>{record.inspectionAQL.criticalMinorLevel || 0}</p>
                    </span>
                  </div>
                </Descriptions.Item>
                <Descriptions.Item label="Defectives Accepted">
                  <div className={classes.groupAQL}>
                    <span>
                      <p>Critical</p>
                      <p>{sample.defectAccepted?.critical ?? 0}</p>
                    </span>
                    <span>
                      <p>Major</p>
                      <p>{sample.defectAccepted?.major ?? 0}</p>
                    </span>
                    <span>
                      <p>Minor</p>
                      <p>{sample.defectAccepted?.minor ?? 0}</p>
                    </span>
                  </div>
                </Descriptions.Item>
              </Descriptions>
              <div className={classes.wrapperTable}>
                <span className={classes.title}>PO Detail:</span>
                <Table
                  rowKey={(item, itemIndex) => item.id || itemIndex}
                  pagination={false}
                  className={classes.table}
                  columns={[
                    {
                      title: 'PO #',
                      dataIndex: 'poNo',
                    },
                    {
                      title: 'PO Qty',
                      dataIndex: 'orderQty',
                    },
                    {
                      title: 'PO # of Cartons',
                      dataIndex: 'cartonsNo',
                    },
                    {
                      title: 'Customer Name',
                      dataIndex: 'clientName',
                    },
                    {
                      title: 'Customer PO#',
                      dataIndex: 'clientPONo',
                    },
                  ]}
                  dataSource={record.inspectionSubPOItems}
                />
              </div>
              {children}
            </ProductListItem>
            {hiddenTemplate ? undefined : (
              <WithLoadPOTemplate
                poItemId={record.poItemId}
                productId={record.id}
              >
                {(templateProps) => {
                  // const { inspectionCriteria } = record;
                  return (
                    <Panel title="Linked Template">
                      <SelectTemplate
                        allTemplates={templates}
                        productProfileId={record.id}
                        defaultTemplate={templateProps.template}
                        currentSelectedTemplate={{
                          ...inspectionCriteria,
                        }}
                        selectedTemplate={currentEditProductTemplate.template}
                        openEditTemplate={openEditTemplate}
                        onChangeTemplate={(option) => {
                          onChange({
                            ...record,
                            inspectionCriteria: {
                              ...option?.data,
                            },
                          });
                        }}
                        onClickEdit={() => {
                          let inspectionOption =
                            inspectionCriteria?.isOnlyApplyThisJob
                              ? 'only_apply_this_job'
                              : '';
                          if (inspectionCriteria?.inspectionOption) {
                            inspectionOption =
                              inspectionCriteria?.inspectionOption;
                          }
                          setCurrentEditProductTemplate({
                            poItemId: record.poItemId,
                            productId: record.id,
                            template: {
                              inspectionOption: inspectionOption,
                              name:
                                inspectionCriteria?.name ??
                                templateProps.template?.name,
                              scheme:
                                inspectionCriteria?.scheme ??
                                templateProps.template?.scheme,
                              id: '',
                            },
                            index,
                          });
                          setOpenEditTemplate(true);
                        }}
                        onCancelEdit={() => {
                          setCurrentEditProductTemplate({
                            poItemId: '',
                            productId: '',
                            template: {
                              inspectionOption: '',
                              name: '',
                              scheme: '',
                              id: '',
                            },
                            index: -1,
                          });
                          setOpenEditTemplate(false);
                        }}
                        onOkEdit={(values) => {
                          onChange({
                            ...record,
                            inspectionCriteria: {
                              ...inspectionCriteria,
                              ...values,
                              id: values.template,
                              name: values?.name,
                              scheme: JSON.stringify(values.scheme),
                            },
                          });
                          setOpenEditTemplate(false);
                        }}
                      />
                    </Panel>
                  );
                }}
              </WithLoadPOTemplate>
            )}
          </div>
        );
      }}
    </WithFetchSampleSize>
  );
}
